import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-para-footer',
	templateUrl: './para-footer.component.html',
	styleUrls: ['../../../../auth-layout/auth-layout.component.css'],
})
export class ParaFooterComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
